export default "__VITE_ASSET__D02m6q6$__"